exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".social-login{margin:auto;text-align:center;width:100%}.social-login__actions{display:flex;flex-direction:row}.social-login__action{margin-bottom:10px;width:50%}.social-login__action:first-child{margin-right:8px}.social-login__action:last-child{margin-left:8px}.social-login__action__button{height:42px;padding:0}.social-login__action__button div{padding-top:8px}.social-login__action__button svg{height:100%;margin:auto 0}\n", ""]);

// exports
exports.locals = {
	"social-login": "social-login",
	"social-login__actions": "social-login__actions",
	"social-login__action": "social-login__action",
	"social-login__action__button": "social-login__action__button"
};